<template>
  <div>
    <save-employee-job-assign
      v-if="showSaveModal"
      :http="http"
      :job-titles="jobTitles"
      :emp-number="empNumber"
      @close="onSaveModalClose"
    ></save-employee-job-assign>
    <div class="orangehrm-vertical-padding">
      <profile-action-header
        :action-button-shown="isAuthAdmin"
        @click="onClickAdd"
      >
        {{ $t('general.job_title') }}
      </profile-action-header>
    </div>
    <table-header
      :selected="checkedItems.length"
      :total="total"
      :loading="isLoading"
      @delete="onClickDeleteSelected"
    ></table-header>
    <div class="orangehrm-container">
      <oxd-card-table
        v-model:selected="checkedItems"
        :headers="tableHeaders"
        :items="items?.data"
        :selectable="isAuthAdmin"
        :clickable="false"
        :loading="isLoading"
        row-decorator="oxd-table-decorator-card"
      />
    </div>
    <div v-if="showPaginator" class="orangehrm-bottom-container">
      <oxd-pagination v-model:current="currentPage" :length="pages" />
    </div>
    <delete-confirmation ref="deleteDialog"></delete-confirmation>
  </div>
</template>

<script>
import ProfileActionHeader from '@/orangehrmPimPlugin/components/ProfileActionHeader';
import DeleteConfirmationDialog from '@ohrm/components/dialogs/DeleteConfirmationDialog';
import {APIService} from '@/core/util/services/api.service';
import usePaginate from '@/core/util/composable/usePaginate';
import SaveEmployeeJobAssign from '@/orangehrmPimPlugin/components/jobAssigns/SaveEmployeeJobAssigns';
import usei18n from '@/core/util/composable/usei18n';
import UserRoles from '@/orangehrmTrainigPlugin/constants/UserRoles';
const userAuth = window.appGlobal.user;
export default {
  name: 'EmployeeJobAssigns',

  components: {
    'save-employee-job-assign': SaveEmployeeJobAssign,
    'profile-action-header': ProfileActionHeader,
    'delete-confirmation': DeleteConfirmationDialog,
  },

  props: {
    empNumber: {
      type: String,
      required: true,
    },
    jobTitles: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const http = new APIService(
      window.appGlobal.baseUrl,
      `api/v2/pim/employees/${props.empNumber}/jobAssigns`,
    );
    const {$t} = usei18n();
    const jobAssignNormalizer = data => {
      return data.map(item => {
        return {
          id: item.id,
          name: item.job.name,
          file: item.filePath,
          startDate: item.startDate,
          endDate: item.endDate,
        };
      });
    };

    const {
      showPaginator,
      currentPage,
      total,
      pages,
      pageSize,
      response,
      isLoading,
      execQuery,
    } = usePaginate(http, {
      normalizer: jobAssignNormalizer,
      toastNoRecords: false,
    });
    return {
      http,
      showPaginator,
      currentPage,
      isLoading,
      total,
      pages,
      pageSize,
      execQuery,
      items: response,
    };
  },

  data() {
    return {
      headers: [
        {
          name: 'name',
          title: this.$t('general.name'),
          style: {flex: 1},
        },
        {
          name: 'startDate',
          title: this.$t('general.start_date'),
          style: {flex: 1},
        },
        {
          name: 'endDate',
          title: this.$t('general.end_date'),
          style: {flex: 1},
        },
        {
          name: 'download',
          title: this.$t('general.browse'),
          style: {flex: 1},
          cellType: 'oxd-table-cell-actions',
          slot: 'action',
          cellConfig: {
            delete: {
              onClick: this.openFile,
              component: 'oxd-icon-button',
              props: {
                name: 'eye',
              },
            },
          },
        },
      ],
      checkedItems: [],
      showSaveModal: false,
      showEditModal: false,
      editModalState: null,
    };
  },

  computed: {
    isDisabled() {
      return this.showSaveModal || this.showEditModal;
    },
    tableHeaders() {
      const headerActions = {
        name: 'actions',
        slot: 'action',
        title: 'Actions',
        style: {flex: 1},
        cellType: 'oxd-table-cell-actions',
        cellConfig: {},
      };

      if (this.isAuthAdmin) {
        headerActions.cellConfig.delete = {
          onClick: this.onClickDelete,
          component: 'oxd-icon-button',
          props: {
            name: 'trash',
          },
        };
      }

      /*
    if (this.$can.update(`supervisor`)) {
      headerActions.cellConfig.edit = {
        onClick: this.onClickEdit,
        props: {
          name: 'pencil-fill',
        },
      };
    }
    */

      return Object.keys(headerActions.cellConfig).length > 0
        ? this.headers.concat([headerActions])
        : this.headers;
    },
    isViewer() {
      return userAuth.id != parseInt(this.empNumber) && userAuth.roleId != 1
        ? true
        : false;
    },
    isEmployee() {
      if (this.isSubordinate) return false;

      return [2, 3].includes(userAuth.roleId) && this.isViewer ? true : false;
    },
    isSubordinate() {
      if (userAuth.roleId === UserRoles.ADMIN.id) return false;

      return userAuth.subordinates.includes(
        parseInt(this.empNumber) && userAuth.roleId == UserRoles.SUPERVISOR.id,
      );
    },
    isAuthAdmin() {
      return userAuth.roleId === UserRoles.ADMIN.id;
    },
  },

  methods: {
    onClickDelete(item) {
      this.$refs.deleteDialog.showDialog().then(confirmation => {
        if (confirmation === 'ok') {
          this.deleteItems([item.id]);
        }
      });
    },
    deleteItems(items) {
      if (items instanceof Array) {
        this.isLoading = true;
        this.http
          .deleteAll({
            ids: items,
          })
          .then(() => {
            return this.$toast.deleteSuccess();
          })
          .finally(() => {
            this.isLoading = false;
            this.resetDataTable();
          });
      }
    },
    async resetDataTable() {
      this.checkedItems = [];
      await this.execQuery();
    },
    onClickAdd() {
      this.showEditModal = false;
      this.editModalState = null;
      this.showSaveModal = true;
    },
    onSaveModalClose() {
      this.showSaveModal = false;
      this.resetDataTable();
    },
    openFile(item) {
      window.open(`${window.appGlobal.publicPath}/${item.file}`, '_blank');
    },
  },
};
</script>
